<div class="title" fxLayout="row" fxLayoutAlign="space-between end">
  <h1>{{'プロジェクト情報' | translate}}</h1>

  <div class="basic-button" fxLayoutGap="10px">
    <button *ngIf="userType==USER_TYPE_ADMIN || userType==USER_TYPE_MASTER" mat-raised-button color="primary" [disabled]="!project" (click)="openEditDialog(project)">
      <mat-icon>create</mat-icon>
      <span>{{'編集' | translate}}</span>
    </button>
  </div>
</div>

<div fxLayout="column" fxLayoutAlign="center center">
  <mat-card appearance="outlined" class="mat-elevation-z8" *ngIf="!!project">
    <div class="main" fxLayoutAlign="space-around start" fxLayout="column" fxLayoutGap="20px">
      <div fxLayout="row" fxLayoutAlign="start start" fxFill>
        <div>ID：</div>
        <div>{{ project.project_id }}</div>
      </div>
      <div fxLayout="row" fxLayoutAlign="start start">
        <div>{{'名称：' | translate}}</div>
        <div>{{ project.project_name }}</div>
      </div>
      <div fxLayout="row" fxLayoutAlign="start start">
        <div>{{'備考：' | translate}}</div>
        <div>{{ project.project_desc }}</div>
      </div>
      <div fxLayout="row" fxLayoutAlign="start start">
        <div>{{'使用言語：' | translate}}</div>
        <div>
          <span *ngFor="let lang_name of project.languages; let i=index">
            {{project!.project_base_lang == 'ja' ? project!.languages![i].lang_name : project!.languages![i].lang_name_en }}<br>
          </span>
        </div>
      </div>
      <div fxLayout="row" fxLayoutAlign="start start">
        <div>{{'更新日時：' | translate}}</div>
        <div>{{ project.updated.toDate() | date: 'yyyy/MM/dd HH:mm' }}</div>
      </div>
      <!-- 新しいテーブルの追加 -->
      <div fxLayout="row" fxLayoutAlign="start start" fxFill>
        <table class="styled-table">
          <tr>
            <th>{{'施設名' | translate}}</th>
            <th >{{'本番サイトURL' | translate}}</th>
            <th >{{'ステージングサイトURL' | translate}}</th>
          </tr>
          <tr *ngFor="let facility of facilities">
            <td>{{ facility.facility_names[0].name }}</td>
            <td><a href="{{ facility.site_url }}" target="_blank">{{ facility.site_url }}</a></td>
            <td><a href="{{ facility.site_url_staging }}" target="_blank">{{ facility.site_url_staging }}</a></td>
          </tr>
        </table>
      </div>
      <!-- ここまで -->
    </div>
  </mat-card>
</div>